import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import type { ImageURISource } from 'react-native';

import { IllusEmpty_2 } from '@garnish/core';

import { useContentfulContentTypeEntry } from '@order/Contentful';

import type { Asset } from 'contentful';
export const useMaintenanceModeData = () => {
  const { formatMessage } = useIntl();

  const {
    data: contentfulData,
    fetching: isLoadingContentfulData,
    error: contentfulError,
  } = useContentfulContentTypeEntry<MaintenanceScreenContent>({
    contentType: MAINTENANCE_SCREEN_CONTENT_ID,
  });

  const fallbackBody = formatMessage(messages.maintenanceModeMessage);
  const fallbackIllustration = IllusEmpty_2;

  const contentfulBody = contentfulData?.fields?.body;
  const contentfulIllustration = contentfulData?.fields?.illustration?.fields?.file?.url;

  const body = contentfulBody ?? fallbackBody;
  const illustration: ImageURISource = useMemo(
    () => (contentfulIllustration ? { uri: contentfulIllustration } : fallbackIllustration),
    [contentfulIllustration, fallbackIllustration],
  );

  return useMemo(
    () => ({
      body,
      illustration,
      isLoadingContentfulData,
      contentfulError,
    }),
    [body, illustration, isLoadingContentfulData, contentfulError],
  );
};

type MaintenanceScreenContent = Readonly<{
  body?: string | null;
  illustration?: Asset | null;
}>;

const MAINTENANCE_SCREEN_CONTENT_ID = 'maintenanceScreen';

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  maintenanceModeMessage: {
    defaultMessage: `Apologies, we're down for maintenance right now.`,
    description: 'Maintenance Mode | Fallback Message',
  },
});
